import { createApp } from 'vue'
import App from './App.vue'
import __ from './helper/translation'

createApp(App)
  .mixin({
    methods: {
      __(key, replace) {
        return __(key, replace)
      },
    },
  })
  .mount('#ticketApp')
